import { FC, useState } from "react";
import { isEmpty } from "lodash";
import { Link, Paper, Stack, Typography } from "@mui/material";
import __ from "src/utils/Translations";
import { LogLevel, useLogStatus } from "src/utils/newRelic/useLogStatus";
import AbsenceTypeItem from "src/Pages/Company/Absences/AbsenceRecords/AbsenceRecordsBalances/AbsenceTypeItem";
import { IAbsenceType } from "src/Pages/Company/Absences/AbsenceRecords/AbsenceRecords.models";

interface IAbsenceTypeListProps {
  employeeId: string;
  label: string;
  data: IAbsenceType[];
}

const AbsenceTypeList: FC<IAbsenceTypeListProps> = ({
  employeeId,
  label,
  data,
}) => {
  const logStatus = useLogStatus();
  const [forceExpand, setForceExpand] = useState(true);

  if (!employeeId) {
    logStatus({
      level: LogLevel.DEBUG,
      message: "No employee ID provided.",
      file: "AbsenceTypeList.tsx",
    });
  }

  if (!data || isEmpty(data)) return null;

  const toggleAll = () => {
    setForceExpand((prev) => !prev);
  };

  return (
    <>
      <Stack direction="row" justifyContent="space-between">
        <Typography
          variant="subtitle1"
          component="h3"
          color="grey.700"
          fontWeight={700}
        >
          {__(label)}:
        </Typography>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <Link
          color="text.primary"
          component="button"
          fontSize="1rem"
          onClick={toggleAll}
        >
          {forceExpand ? __("Zwiń") : __("Rozwiń")} {__("wszystkie")}
        </Link>
      </Stack>
      <Paper
        sx={{
          padding: "2rem",
          margin: "1rem 0 2rem",
        }}
      >
        {data.map((type) => (
          <>
            <AbsenceTypeItem
              key={type.id}
              employeeId={employeeId}
              data={type}
              forceExpand={forceExpand}
            />
            {type.absenceTypes?.map((secondaryType) => (
              <AbsenceTypeItem
                key={secondaryType.id}
                employeeId={employeeId}
                data={secondaryType}
                forceExpand={forceExpand}
                isSecondary
              />
            ))}
          </>
        ))}
      </Paper>
    </>
  );
};

export default AbsenceTypeList;
